import { http } from "..";

/**
 * Gets rankings
 * @returns axios http response
 */
export const getRankings = () => {
  return http.get(`/ranking`);
};
